<header class="card topbar">
  <div class="head-block">
    <div class="head-meta">Painel de fechamento</div>
    <h1>Conferência Mercado Livre</h1>
    <div class="head-summary">
      <span class="summary-pill">{{ activePeriodLabel }}</span>
      <span class="summary-pill">{{ operationsTotal }} pedidos no período</span>
    </div>
  </div>
  <div class="head-actions">
    <div class="head-status-row">
      <span class="status-pill" [class.pending]="busy">
        <span class="status-dot"></span>
        {{ isWeekClosed ? 'Extrato pronto para conferência' : 'Atualizando informações' }}
      </span>
      <div class="period-tabs no-print" role="group" aria-label="Atalhos de período">
        <button type="button" class="period-tab" [class.active]="isToday" [attr.aria-pressed]="isToday" (click)="quickRange.emit('today')">Hoje</button>
        <button type="button" class="period-tab" [class.active]="isWeek" [attr.aria-pressed]="isWeek" (click)="quickRange.emit('week')">Semana</button>
        <button type="button" class="period-tab" [class.active]="isMonth" [attr.aria-pressed]="isMonth" (click)="quickRange.emit('month')">Mês</button>
      </div>
    </div>
    <div class="head-utility-row">
      <button type="button" class="btn btn-secondary no-print" (click)="print.emit()">Imprimir</button>
      <details class="nav-menu no-print">
        <summary class="btn btn-secondary">Outros painéis</summary>
        <div class="nav-menu-list">
          <a href="/relatorios">Relatórios</a>
          <a href="/publicidade">Publicidade</a>
          <a href="/anuncios">Anúncios</a>
          <a href="/reputacao">Reputação</a>
          <button type="button" (click)="settings.emit()">Comissão dos funcionários</button>
        </div>
      </details>
      <button type="button" class="btn btn-secondary no-print" (click)="logout.emit()">Sair</button>
    </div>
  </div>
</header>
